export const getBillCurrencyTooltipText = (currencyCode) => {
    if (!currencyCode) {
        return null;
    }
    return `The bill currency is ${currencyCode}, so your vendor can only receive ${currencyCode}.`;
};
